export default {
  buttons: {
    reschedule: 'Перенести дату',
    'reschedule-change-address': 'Перенести / Изменить адрес',
    'add-time': 'Добавить время',
  },
  'pickup-time-min-title': 'Минимальное время забора',
  'pickup-time-max-title': 'Максимальное время забора',
  'pickup-date': 'Выберите дату доставки',
  'change-address': {
    title: 'Вы изменили адрес',
    description: 'Пожалуйста, подождите, пока мы обработаем ваш заказ, после чего предоставим ссылку для отслеживания.',
    error: 'Извините, доставка по выбранному адресу невозможна. Пожалуйста, введите другой адрес',
  },
  'coolbox-modal': {
    message: 'Вашему лекарству требуется доставка в строго определённое время.<br>Вы уверены, что хотите перенести дату доставки?',
    rescheduleButton: 'Да, перенести',
    cancelButton: 'Отмена',
  },
}
